enum RoutingPaths {
  root = '/',
  bp = '/bp',
  comcast = '/comcast',
  messages = '/messages',
  messageDetail = '/messages/:messageId',
  contactUs = '/messages/contact-us',
  stopLossAndLimitOrders = '/stop-loss-and-limit-orders',
  portfolio = '/portfolio',
  accountDocuments = '/account-documents',
  accountBalanceReports = '/account-balance-reports',
  historicalAccountBalance = '/account-balance-reports/historical-share-balance',
  currentAccountBalance = '/account-balance-reports/current-share-balance',
  dividends = '/dividends',
  dividendManagement = '/dividends/management',
  accountManagement = '/account-management',
  alerts = '/alerts',
  register = '/register',
  registerDspp = '/register/dspp',
  registerDsppContinue = '/register/dspp/continue',
  externalRegister = '/external/register',
  resetProfileVerify = '/reset-profile/verify',
  onlineRegistration = '/register/onlineRegistration',
  idvUnderReview = '/identity-verification/under-review',
  idvError = '/identity-verification/error',
  idvConfirmation = '/identity-verification/confirmation',
  accountInformation = '/account-management/account-information',
  eDeliveryPreferences = '/account-management/delivery-preferences',
  proxyPreferences = '/account-management/proxy-preferences',
  accountInformationRedirect = 'account-information',
  informationalEsignConsent = '/informational/esign-consent',
  informationalOnlineAccessAgreement = '/informational/online-access-agreement',
  buy = '/buy',
  lostCertificates = '/lost-certificates',
  logout = '/transactional/anonymous/signout',
  logoutToLanding = `/transactional/anonymous/signout?landingPage=true`,

  registerSurfaceRedirect = '/umbraco/surface/RegisterSurface/Redirect',
  profileSettingsSurfaceRedirect = '/umbraco/surface/ProfileSettingsSurface/Redirect',

  resetProfileSurface = '/umbraco/surface/RecoverySurface/ResetProfile',

  sell = '/transactional/authenticated/authenticated-sell',
  checks = '/transactional/authenticated/checks',
  brokerInstructions = '/transactional/authenticated/broker-instructions',
  espp = '/transactional/anonymous/espp/management',
}

export const registrationHeaderPaths = [
  RoutingPaths.register,
  RoutingPaths.onlineRegistration,
  RoutingPaths.externalRegister,
  RoutingPaths.registerDspp,
  RoutingPaths.registerDsppContinue,
  RoutingPaths.idvUnderReview,
  RoutingPaths.idvError,
  RoutingPaths.idvConfirmation,
];

export default RoutingPaths;
